import { Outlet } from 'react-router-dom';
import Content from '../../components/content';
import { UsersRound } from 'lucide-react';

export function PatientsLayout() {
    return (
        <Content headerTitle="Patients" headerIcon={<UsersRound size="20" />} padding={false}>
            {{ content: <Outlet /> }}
        </Content>
    );
}
